import { render, staticRenderFns } from "./MarketTable.vue?vue&type=template&id=18438d04&scoped=true&"
import script from "./MarketTable.vue?vue&type=script&lang=js&"
export * from "./MarketTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketTable.vue?vue&type=style&index=0&id=18438d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18438d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable})
